<template>
  <v-col cols="12">
    <b style="color: red">{{ errorMess }}</b>
    <template v-if="!loading">
      <v-row>
        <v-col cols="12" class="border">
          <v-row>
            <v-col cols="4">
              <b style="display: inline">Upload Type: </b>
            </v-col>
            <v-col cols="8">
              <v-radio-group
                v-model="uploadDesign"
                :mandatory="false"
                class="large"
                row
                style="text-align: center; display: inline"
              >
                <v-radio label="URL" value="url" @change="reset"></v-radio
                >&nbsp;
                <v-radio
                  label="Upload Design"
                  value="file"
                  @change="reset"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="8" class="border" v-if="uploadDesign == 'file'">
          <input
            type="file"
            @change="onFileDesignChange"
            ref="inputDesign"
            style="display: none"
          />

          <v-col cols="12" v-if="imageDesign.length > 0">
            <img
              v-bind:src="imageDesign[0].image"
              style="height: 120px"
            /><br />
            {{ size }}
          </v-col>
          <v-btn @click="$refs.inputDesign.click()" color="grey" small dark
            >Select Design</v-btn
          >
        </v-col>

        <v-col cols="8" class="border" v-else-if="uploadDesign == 'url'">
          <v-text-field
            label="Design URL"
            v-model="designURL"
            @change="checkURL"
            @keyup="checkURL"
          ></v-text-field>

          <template v-if="designURL != ''">
            <v-col cols="12">
              <img :src="designURL" style="height: 120px" />
            </v-col>
            <p style="color: red" v-if="informTextURL != ''">
              {{ informTextURL }}
            </p>
            Size: {{ sizeURL }}
          </template>
        </v-col>

        <v-col cols="8" class="border" v-else> Select Upload Type </v-col>

        <v-col cols="4" class="border">
          <v-row>
            <v-col cols="5">Designer:</v-col>
            <v-col cols="7"
              ><b>{{ designer_id }}</b>
            </v-col>
            <v-col cols="5">Vendor</v-col>
            <v-col cols="7">
              <select class="form-control" v-model="vendorID">
                <option v-for="i in listVendor" :key="i._id" :value="i._id">
                  {{ i.vendor_code }}
                </option>
              </select>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="border">
        <v-col cols="12">
          <template v-if="variants.length >= 100">
            <b style="color: red">{{ variants.length }} selected variant(s)</b>
          </template>
          <template v-else>
            {{ variants.length }} selected variant(s)
          </template>
        </v-col>
        <v-col>
          <v-row>
            <template>
              <v-col v-for="i in variantsTemp" :key="i[0]" cols="4"
                >{{ i[1] }}: {{ i[0] }}</v-col
              >
            </template>
            <!-- {{variantsTemp.toString()}} -->
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <template v-if="uploadDesign == 'file'">
            <v-btn
              color="success"
              @click="uploadImagePreview"
              v-if="imageDesign.length > 0 && vendorID != ''"
              >Upload Design</v-btn
            >
            <v-btn color="success" @click="uploadImagePreview" v-else disabled
              >Upload Design</v-btn
            >
          </template>
          <template v-else-if="uploadDesign == 'url'">
            <v-btn
              color="blue"
              dark
              v-if="showBtnURL && vendorID != ''"
              @click="imageURLSave"
              >Save URL</v-btn
            >
            <v-btn color="blue" v-else disabled>Save URL</v-btn>
          </template>
        </v-col>
      </v-row>
      <v-btn small class="white--text" color="warning" @click="cancelData">
        Cancel <v-icon right dark>mdi-window-close</v-icon>
      </v-btn>
    </template>
    <template v-else>
      <img v-bind:src="require('../../assets/loading/loading.gif')" />
    </template>
  </v-col>
</template>

<script>
import axios from "axios";
import Amplify, { Auth } from "aws-amplify";
//import Multiselect from 'vue-multiselect'

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

const API_ENDPOINT = window.domain + "products/upload-image";
const MAX_IMAGE_SIZE = 6300000;

export default {
  name: "add-design",

  props: {
    variants: Array,
    designer_id: String,
    product_id: String,
    product_code: String,
  },

  data: () => ({
    loading: false,
    listVendor: [],
    imageDesign: [],
    imageFormat: "",
    uploadURL: "",
    vendorID: "",
    variantsTemp: [],
    errorMess: "",
    listVariants: [],
    size: "",
    uploadDesign: "",
    designURL: "",
    showBtnURL: false,
    sizeURL: "",
    informTextURL: "",
  }),

  watch: {
    designURL() {
      this.getSizeURL();
    },
  },

  methods: {
    cancelData() {
      this.$root.$refs.normalProductDesigner.offDialog();
    },

    async loadData() {
      var currentSession = await this.$root.$refs.App.currentSession(
        "add-design-to-variant-loadData"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await axios
          .get(window.domain + "vendors", {
            headers: { Authorization: currentSession.accessToken },
          })
          .then((response) => {
            this.listVendor = response.data.data;
          })
          .catch((error) => {
            console.log("error ", error);
          });
      } else {
        console.log(
          "currentSession add-design-to-variant-loadData-undefined: ",
          currentSession
        );
      }
    },

    reset() {
      this.designURL = "";
      this.imageDesign = [];
      this.imageFormat = "";
      this.size = "";
      this.sizeDesign = "";
      this.sizeURL = "";
      if (this.$refs.inputDesign != undefined)
        this.$refs.inputDesign.value = "";
    },

    checkURL() {
      console.log("Check: ", this.designURL.indexOf("https://gba-public.s3"));
      if (this.designURL.indexOf("https://gba-public.s3") > -1) {
        this.showBtnURL = true;
        this.informTextURL = "";
      } else {
        this.showBtnURL = false;
        this.informTextURL =
          "Design image must be saved in gba-public folder of Amazon S3";
      }
      console.log("showBtnURL: ", this.showBtnURL);
    },

    getSizeURL() {
      let img = new Image();
      img.src = this.designURL;
      img.onload = () => {
        this.sizeURL = img.width + "x" + img.height;
      };
    },

    async imageURLSave() {
      this.loading = true;
      var currentSession = await this.$root.$refs.App.currentSession(
        "add-design-to-variant-imageURLSave"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        var response = await fetch(window.domain + "products/upload-image", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify({
            image_base64: "",
            image_folder: "product-design",
            image_format: "",
            product_id: this.$route.params.id,
            designer_username: this.designer_id,
            product_code: this.product_code,
            vendor_id: this.vendorID,
            variant_ids: this.listVariants,
            image_url: this.designURL,
          }),
        })
          .then((response) => response.json())
          .catch((error) => {
            console.log("Err: ", error);
          });
        console.log("imageURLSave response: ", response);

        if (response.error_message == "") {
          this.loading = false;
          this.imageDesign = [];
          this.$root.$refs.normalProductDesigner.offDialog();
        } else {
          this.errorMess = response.error_message;
        }
      } else {
        console.log(
          "currentSession add-design-to-variant-imageURLSave-undefined: ",
          currentSession
        );
      }
    },

    onFileDesignChange(e) {
      this.imageDesign = [];
      let files = e.target.files; // || e.dataTransfer.files
      if (!files.length) return;

      this.createImage(files[0]);
    },

    cancelImageDesign() {
      this.imageDesign = [];
    },

    createImage(file) {
      this.errorMess = "";
      let reader = new FileReader();
      reader.onload = (e) => {
        if (e.target.result.includes("data:image/jpeg")) {
          this.imageFormat = "image/jpeg";
        } else if (e.target.result.includes("data:image/png")) {
          this.imageFormat = "image/png";
        } else if (e.target.result.includes("data:image/bmp")) {
          this.imageFormat = "image/bmp";
        } else {
          return (this.errorMess = "Wrong file type - JPG/PNG/BMP only.");
        }

        console.log("e.target.result.length: ", e.target.result.length);
        if (e.target.result.length > MAX_IMAGE_SIZE) {
          return (this.errorMess = "Image is loo large - 4.7MB maximum");
        }

        let img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          this.size = img.width + "x" + img.height;
          console.log(img.width + "x" + img.height);
        };

        var item = {
          image: e.target.result,
          format: this.imageFormat,
        };
        this.imageDesign.push(item);
      };
      reader.readAsDataURL(file);
    },

    async uploadImagePreview() {
      this.loading = true;
      var base64EncodedStr = this.imageDesign[0].image.split(",")[1];
      var currentSession = await this.$root.$refs.App.currentSession(
        "add-design-to-variant-uploadImagePreview"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        let response = await axios({
          method: "POST",
          url: API_ENDPOINT,
          headers: { Authorization: currentSession.accessToken },
          data: {
            image_base64: base64EncodedStr,
            image_folder: "product-design",
            image_format: this.imageDesign[0].format,
            product_id: this.$route.params.id,
            designer_username: this.designer_id,
            product_code: this.product_code,
            vendor_id: this.vendorID,
            variant_ids: this.listVariants,
          },
        }).catch((error) => {
          console.log("Err: ", error);
        });
        console.log("uploadImagePreview response: ", response);
        if (response.data.error_message == "") {
          this.loading = false;
          this.imageDesign = [];
          this.$root.$refs.normalProductDesigner.offDialog();
        } else {
          this.errorMess = response.data.error_message;
        }
      } else {
        console.log(
          "currentSession add-design-to-variant-uploadImagePreview-undefined: ",
          currentSession
        );
      }
    },
  },
  async mounted() {
    console.log("variants: ", this.variants);
    console.log("product_code: ", this.product_code);
    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });

      var temp = new Map();
      for (let j = 0; j < this.variants.length; j++) {
        for (let k = 0; k < this.variants[j].options.length; k++) {
          temp.set(
            this.variants[j].options[k].value,
            this.variants[j].options[k].name
          );
        }
        this.listVariants.push(this.variants[j].variant_id);
      }
      this.variantsTemp = Array.from(temp);
      console.log(this.variantsTemp);
      //console.log(temp)
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>